import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom, map } from 'rxjs';
import { SystemService } from './system.service';
import { API_URL } from 'common/constants/sm-constants';
import { EncryptionAndDecryption } from './encrypt-decrypt.service';
@Injectable({
    providedIn: 'root'
})
export class SmApiService {
    post(deleteUrl: API_URL, deleteData: any) {
        throw new Error("Method not implemented.");
    }
    constructor(protected http: HttpClient, protected systemService: SystemService) { }

    // getWithoutToken(url): Promise<any> {
    //     return this.http.get<any>(url).toPromise();
    // }

    // postWithoutToken(url, body): Promise<any> {
    //     return this.http
    //         .post<any>(url, body)
    //         .pipe(
    //             map(data => {
    //                 return data;
    //             })
    //         )
    //         .toPromise();
    // }

    async get(url, token: any = null): Promise<any> {
        return this.http
            .get<any>(url)
            .pipe(
                map(response => {
                    if (response?.details) {
                        const decrypted = EncryptionAndDecryption.decryption(response.details);
                        return {
                            ...response,
                            details: decrypted
                        };
                    }
                    return response;
                })
            )
            .toPromise();
    }

    async getDataByParams(url, queryparams): Promise<any> {
        return this.http
            .get<any>(url)
            .pipe(
                map(response => {
                    if (response?.details) {
                        const decrypted = EncryptionAndDecryption.decryption(response.details);
                        return {
                            ...response,
                            details: decrypted
                        };
                    }
                    return response;
                })
            )
            .toPromise();
    }

    async getData(url): Promise<any> {
        return this.http
            .get<any>(url)
            .pipe(
                map(response => {
                    if (response?.details) {
                        const decrypted = EncryptionAndDecryption.decryption(response.details);
                        return {
                            ...response,
                            details: decrypted
                        };
                    }
                    return response;
                })
            )
            .toPromise();
    }

    // postData(url: string, formData: any, token: string = ''): Promise<any> {
    //     // console.log('POST DATA', formData);

    //     let finalPayload: any;
    //     console.log(formData);
        
    //     if (formData instanceof FormData) {
    //         // Convert FormData to plain object (excluding files if needed)
    //         const plainObj: any = {};
    //         const files: { key: string; file: File | Blob }[] = [];

    //         formData.forEach((value: any, key: string) => {
    //             if (
    //                 typeof File !== 'undefined' && value instanceof File ||
    //                 typeof Blob !== 'undefined' && value instanceof Blob
    //             ) {
    //                 files.push({ key, file: value });
    //             } else {
    //                 // Handle keys with [index] for arrays (e.g., studentIds[0])
    //                 const arrayMatch = key.match(/^(.+)\[(\d+)\]$/);
    //                 if (arrayMatch) {
    //                     const arrayKey = arrayMatch[1];
    //                     if (!plainObj[arrayKey]) {
    //                         plainObj[arrayKey] = [];
    //                     }
    //                     plainObj[arrayKey].push(value);
    //                 } else {
    //                     plainObj[key] = value;
    //                 }
    //             }
    //         });

    //         // Encrypt only the plain data
    //         const encrypted = EncryptionAndDecryption.encryption(plainObj);

    //         // Create new FormData and append encrypted 'details'
    //         const encryptedFormData = new FormData();
    //         encryptedFormData.append('details', encrypted);

    //         // Re-append files (if required by backend)
    //         files.forEach(({ key, file }) => {
    //             encryptedFormData.append(key, file);
    //         });

    //         finalPayload = encryptedFormData;

    //     } else {
    //         // If plain object, encrypt whole thing
    //         const encrypted = EncryptionAndDecryption.encryption(formData);
    //         finalPayload = { details: encrypted };
    //     }

    //      console.log('FINAL PAYLOAD', finalPayload);

    //     return this.http
    //         .post<any>(url, finalPayload)
    //         .pipe(
    //             map(response => {
    //                 if (response?.details) {
    //                     const decrypted = EncryptionAndDecryption.decryption(response.details);
    //                     return {
    //                         ...response,
    //                         details: decrypted
    //                     };
    //                 }
    //                 return response;
    //             })
    //         )
    //         .toPromise();
    // }
    postData(url: string, formData: any, token: string = ''): Promise<any> {
    const skipEncryption = url.includes('/api/importMentorMapping/importdata') || url.includes('/api/mentorImport/importExcel');

  let finalPayload: any;

  if (formData instanceof FormData) {
    if (skipEncryption) {
      console.log('Skipping encryption for:', url);
      finalPayload = formData; // return original formData as-is
    } else {
      const plainObj: any = {};
      const files: { key: string; file: File | Blob }[] = [];

      formData.forEach((value: any, key: string) => {
        if (
          typeof File !== 'undefined' && value instanceof File ||
          typeof Blob !== 'undefined' && value instanceof Blob
        ) {
          files.push({ key, file: value });
        } else {
          const arrayMatch = key.match(/^(.+)\[(\d+)\]$/);
          if (arrayMatch) {
            const arrayKey = arrayMatch[1];
            if (!plainObj[arrayKey]) {
              plainObj[arrayKey] = [];
            }
            plainObj[arrayKey].push(value);
          } else {
            plainObj[key] = value;
          }
        }
      });

      const encrypted = EncryptionAndDecryption.encryption(plainObj);

      const encryptedFormData = new FormData();
      encryptedFormData.append('details', encrypted);

      files.forEach(({ key, file }) => {
        encryptedFormData.append(key, file);
      });

      finalPayload = encryptedFormData;
    }
  } else {
    finalPayload = skipEncryption
      ? formData
      : { details: EncryptionAndDecryption.encryption(formData) };
  }

  return this.http
    .post(url, finalPayload)
    .pipe(
      map((response:any) => {
        if (!skipEncryption && response?.details) {
          const decrypted = EncryptionAndDecryption.decryption(response.details);
          return { ...response, details: decrypted };
        }
        return response;
      })
    )
    .toPromise();
    }



    getBlobUrl(url): any {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                'Access-Control-Allow-Origin': '*'
            }),
            responseType: 'blob' as 'json'
        };
        return firstValueFrom(this.http.get<any>(url));
    }

    fetchSignedUrl(signedUrl) {
        this.http.get(signedUrl, { responseType: 'blob' }).subscribe((url: any) => {
            return url;
        });
    }

    convertFormData(body) {
        var formData: any = new FormData();
        Object.keys(body).forEach(a => {
            formData.append(a.toString(), body[a]);
        });
        return formData;
    }

    getImage(apiUrl: string, type: any = 'blob'): Promise<any> {
        return this.http.get(apiUrl, { responseType: type }).toPromise();
    }

    getFile(apiUrl: string, payload, type: any = 'blob'): Promise<any> {
        const encryptedPayload = { details: EncryptionAndDecryption.encryption(payload) };
        return this.http.post(apiUrl, encryptedPayload, { responseType: type }).toPromise();
    }
}